<template>
  <div class="statistics">

    <div class="row">
      <div class="key">数量合计:</div>
      <div class="val">{{ statistics.num }}</div>
    </div>
    <div class="row">
      <div class="key">金额合计:</div>
      <div class="val">{{ statistics.kin.toFixed(2) }}</div>
    </div>


  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },

  },
  computed: {
    statistics() {
      let total = {
        num: 0,
        kin: 0,

      }
      this.checkedList.forEach(item => {
        total.kin += (item.possible_num * item.confirm_price) - 0
        total.num += item.possible_num
      })

      return total
    }
  },
  data() {
    return {

    };
  },
  methods: {

  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 60px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}

/deep/.el-popover {
  background-color: pink !important;
}
</style>